import React from 'react';
import { User, UserCheck, Paperclip, Play } from 'lucide-react';
import AuthenticatedMedia from './AuthenticatedMedia';

const ChatMessage = ({ message, isAdmin }) => {
  const formatTime = (date) => {
    return new Date(date).toLocaleTimeString('en-US', {
      hour: '2-digit',
      minute: '2-digit',
    });
  };

  return (
    <div
      className={`d-flex gap-2 mb-3 ${
        isAdmin ? 'justify-content-start' : 'justify-content-end'
      }`}
    >
      <div style={{ maxWidth: 'min(520px, 82%)', minWidth: 0 }}>
        <div
          className='rounded-3 px-3 py-2'
          style={{
            backgroundColor: isAdmin ? '#ffffff' : '#667eea',
            color: isAdmin ? '#000' : '#fff',
            boxShadow: '0 1px 2px rgba(0,0,0,0.1)',
          }}
        >
          {!isAdmin && (
            <div className='d-flex align-items-center gap-1 mb-1'>
              <User size={14} />
              <small className='fw-semibold'>
                {message.sender?.fullName || message.sender?.email || 'Guest / Unregistered User'}
              </small>
            </div>
          )}
          {isAdmin && (
            <div className='d-flex align-items-center gap-1 mb-1'>
              <UserCheck size={14} className='text-primary' />
              <small className='fw-semibold text-primary'>
                Customer Support
              </small>
            </div>
          )}

          {(message.messageType === 'image' || message.imageUrl) && (
            <div className='mb-2'>
                <AuthenticatedMedia
                  src={message.imageUrl}
                  preview={false}
                  openOnClick
                  alt={message.fileName || 'Chat image'}
                  style={{
                    maxWidth: '260px',
                    maxHeight: '280px',
                    width: '100%',
                    objectFit: 'contain',
                    borderRadius: '10px',
                    display: 'block',
                  }}
                />
              {message.fileName && (
                <small className={isAdmin ? 'text-muted' : 'text-white-50'}>
                  {message.fileName}
                </small>
              )}
            </div>
          )}

          {(message.messageType === 'video' || message.videoUrl) && (
            <div className='mb-2'>
              <AuthenticatedMedia
                as='video'
                src={message.videoUrl}
                preview={false}
                showOpenButton
                controls
                preload='metadata'
                style={{
                  maxWidth: '280px',
                  maxHeight: '320px',
                  width: '100%',
                  borderRadius: '10px',
                  display: 'block',
                  backgroundColor: '#000',
                }}
              />
              <div className='d-flex align-items-center gap-1 mt-1'>
                <Play
                  size={12}
                  className={isAdmin ? 'text-muted' : 'text-white-50'}
                />
                <small className={isAdmin ? 'text-muted' : 'text-white-50'}>
                  {message.fileName || 'Video'}
                </small>
              </div>
              <span
                className={`small d-block mt-1 ${isAdmin ? 'text-primary' : 'text-white-50'}`}
              >
                Open video in new tab ↗
              </span>
            </div>
          )}

          {message.message && <p className='mb-0'>{message.message}</p>}

          {message.attachments && message.attachments.length > 0 && (
            <div className='mt-2'>
              {message.attachments.map((attachment, index) => (
                <a
                  key={index}
                  href={attachment.url}
                  target='_blank'
                  rel='noopener noreferrer'
                  className={`d-flex align-items-center gap-1 text-decoration-none ${
                    isAdmin ? 'text-primary' : 'text-white'
                  }`}
                >
                  <Paperclip size={14} />
                  <small>{attachment.name}</small>
                </a>
              ))}
            </div>
          )}
        </div>

        <small
          className={`d-block mt-1 ${
            isAdmin ? 'text-start' : 'text-end'
          } text-muted`}
        >
          {formatTime(message.createdAt)}
        </small>
      </div>
    </div>
  );
};

export default ChatMessage;
